import styled, { css } from 'styled-components'

import { getRemValue } from '../../../utils/styling'

import { Box } from '../../../shared_components/UI/Box'
import { StyledDomElement } from '../../../App'

export const Container = styled.div`
  padding: 2rem 0 4rem;
  @media screen and (max-width: 1000px) {
    padding-top: 32px;
  }
`

export const RadialGlow = styled.div`
  position: absolute;
  right: -20vw;
  top: 0;

  width: 100vw;

  fill: radial-gradient(
    25.55% 47.75% at 38.79% 69.91%,
    #f9e159 33.53%,
    #1f8ef5 82.36%,
    #f9e159 100%
  );

  opacity: 0.5;
  z-index: 0;
  pointer-events: none;
  filter: blur(250px);
`

export const PadWrapper = styled.div`
  @media screen and (max-width: 1000px) {
    /* padding-top: 32px; */
  }
`

export const Subheader = styled.div`
  width: 100%;
  margin: 32px 0;
  font-family: 'Space Grotesk';
  font-size: ${getRemValue(16)};
  line-height: 1.75rem;

  @media (min-width: 768px) {
    margin-bottom: 78px;
    line-height: 2rem;
    width: 630px;
    font-size: ${getRemValue(22)};
  }
`

export const PoolsSection = styled.div<{ marginTop?: string }>`
  margin-bottom: 5rem;
  margin-top: ${(props) => props.marginTop};
`

export const ButtonWrapper = styled.div`
  display: flex;
  display: flex;
  justify-content: center;
`

export const LoadingText = styled.p`
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  font-size: 2.25rem;
  line-height: 2.5rem;
  text-align: center;
  text-transform: uppercase;
`

export const PoolCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }

  @media (min-width: 1280px) {
    display: grid;
    margin-bottom: 4rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 2rem;
  }
`

export function hexToRgba(hex: string, alpha: number) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

type HomePageSectionProps = {
  zIndex?: string
  ref?: any
} & StyledDomElement

export const HomePageSection = styled.div<HomePageSectionProps>`
  position: relative;
  z-index: ${(props) => props.zIndex};
`

export const HeroBox = styled(Box)`
  border-radius: 20px;
  padding: 6rem 2rem;
  background-image: url('/img/crowd-station.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  max-width: calc(100vw - 4rem);
  min-height: min(775px, 80vh);
  :after {
    content: '';
    position: absolute;
    overflow: hidden;
    border-radius: 20px;
    border: 1px solid ${hexToRgba('#F9E159', 0.75)};
    width: 100%;
    max-width: calc(100vw - 4rem);
    height: 100%;
    z-index: 1;
    background: ${hexToRgba('#000000', 0.7)};
  }
  @media (max-width: 768px) {
    max-width: calc(100vw - 2rem);
    padding: 2rem 1rem;
    min-height: auto;
    :after {
      max-width: calc(100vw - 2rem);
    }
  }
`

type HowToInvestFullWidthSectionProps = {
  isDarkTheme: boolean
} & StyledDomElement

export const HowToInvestFullWidthSection = styled.div<HowToInvestFullWidthSectionProps>`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  position: relative;
  margin-top: -35px;
  padding-top: 217px;
  background: url('./upcoming-cover-labs.png');
  background-repeat: no-repeat;
  background-size: 140%, 100%;
  background-position: top, bottom;

  @media screen and (min-width: 1000px) {
    margin-top: -113px;
    padding-top: 450px;
    background-size: 60%, 100%;
  }
`

export const ForceFullWidth = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`

export const TitlesWrapper = styled.div`
  width: 100%;
  text-align: center;
  h2,
  h3,
  ${Subheader} {
    margin: auto;
  }
  gap: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 1280px) {
    width: 819px;
  }
`

type TitleProps = {
  fontSize?: number | null
  textColor?: string
  noUnderscore?: boolean
  isActive?: boolean
  maxWidth?: number
  uppercase?: boolean
} & StyledDomElement

export const Title = styled.h2<TitleProps>`
  font-style: normal;
  font-family: 'Space Grotesk';
  font-weight: 800;
  font-size: ${({ fontSize }) => getRemValue(fontSize ?? 32)};
  line-height: 42px;
  letter-spacing: -0.04em;
  z-index: 10;
  margin-bottom: 32px;
  max-width: ${({ maxWidth }) => maxWidth ? `${maxWidth}px` : '100%'};
  transition: 0s;
  @media screen and (min-width: 1000px) {
    font-size: ${({ fontSize }) => getRemValue(fontSize ?? 72)};
    line-height: 86px;
  }
  ${({ uppercase }) =>
    uppercase &&
    css`
      text-transform: uppercase;
    `}
`

export const ButtonsWrapper = styled(Box)`
  flex-direction: column;
  gap: 24px;

  @media (min-width: 1000px) {
    width: 410px;
    gap: 0;
    flex-direction: row;
  }
`

export const SingleButtonWrapper = styled.div`
  display: block;
  width: 100%;

  @media (min-width: 1000px) {
    margin-top: 40px;
    width: unset;
  }
`

export const SectionHeader = styled.p`
  margin-top: 48px;

  font-size: ${getRemValue(16)};
  line-height: 20px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  @media (min-width: 1000px) {
    margin-top: 90px;
    font-size: ${getRemValue(20)};
    line-height: 25px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
  @media screen and (max-width: 1000px) {
    max-width: 120px;
  }
`

export const SectionContentWrapper = styled.div`
  padding-top: 40px;
`

export const ViewAllButtonWrapper = styled.div`
  width: 100%;
  margin-top: 40px;

  @media (min-width: 1000px) {
    margin-top: 60px;
    width: 192px;
  }
`

export const IntroVideo = styled.video`
  position: absolute;
  bottom: 160px;
  right: 0;
  width: 290px;
  height: 163.12px;
  border-radius: 8px;
  @media (max-width: 1000px) {
    position: relative;
    width: 100%;
    height: auto;
    margin-top: 200px;
    margin-bottom: -140px;
  }
`
